<template>
  <validation-observer tag="form" @submit.native.prevent ref="validation">

    <fragment>
      <div class="card-body">
          <h2>Total PowerConsumption</h2>

          <p class="text-muted mb-0">
            Generate screen's total power consumption for a given date range.
          </p>
      </div>

      <ul class="filters">
          <li>
            <div class="row">
              <label class="col-lg-3 col-form-label">Date range</label>
              <div class="col-lg-9">
                  <validation-provider name="date range" vid="date_range" rules="required" v-slot="{ failed }">
                    <input-date-range
                        v-model="filters.dateRange"
                        placeholder=""
                        class="form-control date-range"
                        :class="{ 'is-invalid': failed }"
                      />
                      <c-help-block />
                  </validation-provider>
              </div>
            </div><!-- /.row -->
          </li>
          <li v-if="$isA('admin')">
              <div class="row">
                  <label class="col-lg-3 col-form-label">Media owner</label>
                  <div class="col-lg-9">
                      <validation-provider name="media owners" vid="media_owners" rules="required" v-slot="{ failed }">
                        <multiselect
                            v-model="filters.mediaOwner"
                            placeholder="Select"
                            :preselect-first="false"
                            :show-labels="false"
                            label="name"
                            track-by="id"
                            :options="mediaOwners"
                            :class="{ 'is-invalid': failed }"
                        />
                        <c-help-block />
                    </validation-provider>
                  </div>
              </div><!-- /.row -->
          </li>
      </ul><!-- /.filters -->

      <div class="card-body border-top text-end mt-auto">
          <c-button type="submit" variant="primary" @click="handleGenerateReport('csv')" validate class="ms-auto me-2" >
            Download CSV
          </c-button>
          <c-button type="submit" variant="primary" @click="handleGenerateReport('pdf')" validate class="ms-auto me-2" >
            Download PDF
          </c-button>
      </div>

    </fragment>
  </validation-observer>
</template>

<script>
import { toast } from '@chameleon/chameleon-vue'
import { http } from '@/utils'
import { get, call } from 'vuex-pathify'
import InputDateRange from '@/components/forms/InputDateRange'
import qs from 'qs'
import { downloadBlob } from '@/utils/functions/download-blob'

export default {
  components: {
    InputDateRange
  },
  data () {
    return {
      filters: {
        mediaOwner: null,
        screen: null,
        dateRange: null,
      }
    }
  },

  async created () {
    try {
      await this.getMediaOwners()
    } catch (e) {
      toast('We encountered an error. We have been alerted and will investigate.', 'danger')
      throw e
    }
  },

  computed: {
    mediaOwners: get('lists/mediaOwners/mediaOwners'),
  },

  methods: {
    getMediaOwners: call('lists/mediaOwners/getMediaOwners'),

    async handleGenerateReport (type) {
      const params = {
        media_owner: this.$isA('admin') ? this.filters?.mediaOwner?.id : this.$user.media_owner_id,
        start_date: this.filters.dateRange.startDate,
        end_date: this.filters.dateRange.endDate,
        mode: type
      }
      try {
        if (type === 'csv') {
          downloadBlob(
            await http.get('reports/power-consumptions', {
              responseType: 'blob',
              headers: { accept: 'application/json, text/csv' },
              params,
              paramsSerializer: params => qs.stringify(params, {
                skipNulls: false,
                encode: true
              })
            })
          )
        }

        if (type === 'pdf') {
          const response = await http.get('reports/power-consumptions', { responseType: 'blob', params })
          window.open(window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })))
        }
      } catch (error) {
        toast('We encountered an error. We have been alerted and will investigate.', 'danger')
      }
    }
  }
}
</script>
